import React from "react";
import { Helmet } from "react-helmet-async";

export default function Seo({
    title,
    description,
    keywords,
    url,
    image = "https://qarzhy.kz/og-image.jpg",
    noindex = false,
    children,
}) {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            {keywords ? <meta name="keywords" content={keywords} /> : null}
            <link rel="canonical" href={url} />

            {noindex ? (
                <meta name="robots" content="noindex, nofollow" />
            ) : (
                <meta name="robots" content="index, follow" />
            )}

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Qarzhy" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {children}
        </Helmet>
    );
}